<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Tìm kiếm">
          <div slot="content">
            <div class="form-group col-md-6 col-sm-6 col-xs-12">
              <label>Loại báo cáo</label>
              <b-form-select
                id="pageSize"
                v-model="filterCredit.report_type"
                :options="reportTypes"
                required
                @change="search"
              ></b-form-select>
            </div>

            <div class="form-group col-md-6 col-sm-6 col-xs-12">
              <label>Mạng</label>
              <b-form-select
                id="pageSize"
                v-model="filterCredit.provider"
                :options="providers"
                required
                @change="search"
              ></b-form-select>
            </div>
          </div>
        </va-box>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" title="Đối soát trả sau">
          <div slot="content">
            <b-table    bordered outlined hover responsive :busy="loading" :fields="price_fields" :items="price_items"
                        show-empty>
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h6 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h6>
              </template>

              <template v-slot:cell(id)="data">
                {{ genSeqId(data) }}
              </template>
              <template v-slot:cell(call_date)="data">
                {{ data.item.call_date | format_date }}
              </template>
              <template v-slot:cell(start_time)="data">
                {{ data.item.call_date | format_date_time}}
              </template>
              <template v-slot:cell(end_time)="data">
                {{ addTime(data.item.call_date, data.item.duration) | format_date_time}}
              </template>

            </b-table>
            <div class="mb-5">
              <b-button variant="info" @click="exportCallLogs" class="w-100px"><span
                class="glyphicon glyphicon-export" aria-hidden="true"></span>
                Export
              </b-button>
            </div>
            <div>
              <div class="form-group col-md-6 col-sm-6 col-xs-12">
                <label>Phí trả sau</label>
                <h6>{{creditPayment.credit_payment_amount | format_currency}} VNĐ</h6>
              </div>
              <div class="form-group col-md-6 col-sm-6 col-xs-12">
                <label>Phí ngoại mạng</label>
                <h6>{{creditPayment.external_payment_amount | format_currency}} VNĐ</h6>
              </div>
              <div class="form-group col-md-6 col-sm-6 col-xs-12">
                <label>Tổng chi phí</label>
                <h6>{{creditPayment.total_payment_amount | format_currency}} VNĐ</h6>
              </div>
              <div class="form-group col-md-6 col-sm-6 col-xs-12">
                <label>Ngày thanh toán</label>
                <h6>{{creditPayment.payment_date}}</h6>
              </div>
            </div>
          </div>
        </va-box>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" :title="'Tìm kiếm đối soát ngoại mạng - ' + getProvider(filterCredit.provider)">
          <div slot="content">
            <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items"
                     show-empty>
              <template #table-busy>
                <div class="text-center my-2 mt-5 mb-5">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Đang tải...</strong>
                </div>
              </template>

              <template #empty="scope">
                <h6 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h6>
              </template>

              <template v-slot:cell(id)="data">
                {{ genSeqId(data) }}
              </template>
              <template v-slot:cell(call_date)="data">
                {{ data.item.call_date | format_date }}
              </template>
              <template v-slot:cell(start_time)="data">
                {{ data.item.call_date | format_date_time}}
              </template>
              <template v-slot:cell(end_time)="data">
                {{ addTime(data.item.call_date, data.item.duration) | format_date_time}}
              </template>

            </b-table>
          </div>
          <div slot="footer" class="d-flex align-items-center justify-content-between">
            <div class="page-size-container">
              <span>Hiển thị</span>
              <b-form-select
                id="pageSize"
                v-model="pageSize"
                :options="pageSizes"
                required
              ></b-form-select>
              <span>  dòng</span>
            </div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRow"
              :per-page="pageSize"
              aria-controls="my-table"
            ></b-pagination>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import callCenterAPI from '../../api/callCenter'
import Utils from '../../common/utils'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import {PROVIDER_NAME} from '../../common/constant'

export default {
  name: 'CreditPaymentReport',
  components: {
    'va-box': VABox,
    DatePicker
  },
  data () {
    return {
      filterCredit: {
        report_type: 'CURRENT_MONTH',
        provider: 'VIETTEL'
      },
      creditPayment: {
        credit_payment_amount: 0,
        discount_amount: 0,
        discount_type: 'VALUE',
        discount_value: 0,
        external_payment_amount: 0,
        payment_date: '2022-06-06',
        payment_method: 'DEBIT',
        status: 'UNPAID',
        total_payment_amount: 0,
        current_prices: null,
        current_minutes: null,
      },
      items: [],
      price_items: [],
      price_fields: [
        {
          key: 'provider',
          label: 'Nhà mạng'
        },
        {
          key: 'total_minute',
          label: 'Tổng số phút gọi'
        },
        {
          key: 'price',
          label: 'Giá 1 phút gọi (vnđ)'
        }
      ],
      fields: [
        {
          key: 'call_date',
          label: 'Ngày gọi'
        },
        {
          key: 'number',
          label: 'Số điện thoại'
        },
        {
          key: 'start_time',
          label: 'Thời gian bắt đầu'
        },
        {
          key: 'end_time',
          label: 'Thời gian kết thúc'
        }
      ],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      reportTypes: [
        {text: 'Tháng hiện tại', value: 'CURRENT_MONTH'},
        {text: 'Tháng trước', value: 'PREVIOUS_MONTH'}
      ],
      providers: [
        {text: 'Viettel', value: 'VIETTEL'},
        {text: 'Vinaphone', value: 'VINAPHONE'},
        {text: 'Mobifone', value: 'MOBIFONE'},
        {text: 'Others', value: 'OTHER'}
      ]
    }
  },
  mounted () {
    this.filter()
    this.filterCreditPayment()
  },
  methods: {
    genSeqId (data) {
      return data.index + (this.currentPage - 1) * this.pageSize + 1
    },
    getProvider (provider) {
      if (provider === 'OTHER') {
        return 'Nhà mạng khác'
      }
      return provider[0] + provider.toLowerCase().substr(1, provider.length)
    },
    filterCreditPayment () {
      callCenterAPI.get_credit_payment_report(this.filterCredit).then(res => {
        this.creditPayment = res.data.data
        if (this.creditPayment.current_prices !== null && this.creditPayment.current_minutes !== null) {
          this.price_items = PROVIDER_NAME.map(item => {
            return {
              provider: item === 'other' ? 'Ngoại mạng' : item,
              total_minute: this.creditPayment.current_minutes[item],
              price: this.creditPayment.current_prices[item],
            }
          })
        }
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      callCenterAPI.get_external_report(this.filterCredit, this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    search () {
      this.filter()
      this.filterCreditPayment()
    },
    addTime (start_time, duration) {
      return moment(start_time).add(duration, 'second')
    },
    exportCallLogs () {
      if (this.loading) {
        return
      }
      this.loading = true
      callCenterAPI.export_call_logs(this.filterCredit).then(res => {
        this.loading = false
        let filename = res.data.data.file
        window.location.href = 'https://crm.ity.vn' + filename
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/call_center/CdrReport.vue